import './css/site.css'
import 'core-js/es6/promise'
import 'core-js/es6/array'

import { app } from './app'

app.$mount('#app')



// WEBPACK FOOTER //
// ./WebApp/boot-app.js